import { ShareMessage, MessageTemplates } from '../../../../assets';

const content = `
  <p title=""> The best way to ask for support is by messaging your friends &amp; family directly. If you need some help knowing what to say, you can choose from our ready-to-use message templates to help get started. </p>
  <br />
  <ol title="">
    <li>
      <div>
        <p>Select the <strong>Share a Message</strong> button located in the left sidebar (desktop) or near the top of any fundraising center page (mobile) </p>
        <img src="${ShareMessage}" alt="Share a Message" />
      </div>
    </li>
    <li>
      <div>
        <p>Choose a type of message you&rsquo;d like to send from the list of templates</p>
        <img src="${MessageTemplates}" alt="Share a Message" />
      </div>
    </li>
    <li>Select your preferred message platform or copy the message to paste anywhere you&rsquo;d like</li>
  </ol>
`;

// eslint-disable-next-line @typescript-eslint/naming-convention
export const promoting_your_fundraiser = {
  id: 'p',
  content: {
    articles: [
      {
        title: 'Send a message to promote your fundraiser',
        content,
      },
    ],
  },
};
